import React from 'react';
import {
  TrashIconForButton,
  PlayIconForButton
} from '~/editor/popupMenu/PopupMenuForChapter';
// import { EyeIcon } from '../icons';
import { EyeIcon } from '../icons';

interface ImageItemProps {
  id: number;
  src?: string;
  selected: boolean;
  onClick: () => void;
  onDelete?: () => void;
  file?: Record<string, unknown>;
  video?: boolean;
  type?: string;
}

const ImageItem: React.FC<ImageItemProps> = ({
  id,
  src,
  selected,
  onClick,
  onDelete,
  file,
  video,
  type
}) => {
  const isVideoProcessing = video && !src;

  const handleSelect = () => {
    if (isVideoProcessing) return;

    onClick();
  };

  const openVideoFile = () => {
    const videoWindow = window.open('', '_blank');
    if (videoWindow) {
      videoWindow.document.write(`
        <html>
          <head>
            <title>Video Player</title>
          </head>
          <body style="margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; background-color: black;">
            <video controls autoplay style="max-width: 100%; max-height: 100%;">
              ${
                file!.mediaUrl || file!.url
                  ? `<source src="${
                      file!.mediaUrl || file!.url
                    }" type="video/mp4">`
                  : ''
              }
              Your browser does not support the video tag.
            </video>
          </body>
        </html>
      `);
    }
  };

  const openAudioFile = () => {
    const audioWindow = window.open('', '_blank');
    if (audioWindow) {
      audioWindow.document.write(`
        <html>
          <head>
            <title>Audio Player</title>
          </head>
          <body style="margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; background-color: black;">
            <audio controls autoplay style="width: 80%;">
              ${
                file!.mediaUrl || file!.url
                  ? `<source src="${
                      file!.mediaUrl || file!.url
                    }" type="audio/mpeg">`
                  : ''
              }
              Your browser does not support the audio element.
            </audio>
          </body>
        </html>
      `);
    }
  };

  const openPdfFile = () => {
    const pdfWindow = window.open('', '_blank');
    if (pdfWindow) {
      pdfWindow.location.href = file!.mediaUrl as string;
    }
  };

  return (
    <div>
      <div className="image-item">
        {onDelete && (
          <button onClick={onDelete}>
            <TrashIconForButton
              style={{ marginLeft: '-5px', marginTop: '-5px' }}
            />
          </button>
        )}
        {video && !isVideoProcessing && (
          <button className="video-button" onClick={openVideoFile}>
            <PlayIconForButton />
          </button>
        )}
        {type === 'document' && (
          <button className="preview-button" onClick={openPdfFile}>
            <EyeIcon />
          </button>
        )}
        <div className="skeleton" />
        <img
          key={id}
          src={src}
          alt="img"
          className={(selected ? 'selected ' : '') + 'img'}
          onLoad={e => {
            const el = e.currentTarget;
            el.classList.add('loaded');
            const skeleton = el.previousElementSibling as HTMLDivElement | null;
            if (skeleton && skeleton.classList.contains('skeleton')) {
              skeleton.style.display = 'none';
            }
          }}
          onClick={handleSelect}
        />
        {isVideoProcessing ? (
          <p className="processing">Processing...</p>
        ) : (
          <p onClick={handleSelect}>Select</p>
        )}
      </div>
      {type === 'document' && (
        <div className="document-name">{file!.name as string}</div>
      )}
    </div>
  );
};

export default ImageItem;
